import { TDS_LOGIN_TOOLTIP_MESSAGE, TDS_TOOLTIP_MESSAGE, TDS_WITH_SEEDING, TDS_WITHOUT_SEEDING } from "./constants";

// const aes256 = require("aes256");


// const ENCRYPTION_KEY = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;

// //Encrypting text
// export const encrypt = (payload) => {
//   const encryptedText = aes256.encrypt(ENCRYPTION_KEY, payload);
//   return encryptedText;
// };

// // Decrypting text
// export const decrypt = (encryptedString) => {
//   const decryptedString = aes256.decrypt(ENCRYPTION_KEY, encryptedString);

//   return decryptedString.trim();
// };

// truncate number
export const truncate = (number) => {
  if (number < 1) return Math.floor(number * 100000000) / 100000000;
  return Math.floor(number * 10000) / 10000;
}

export const getTds = (isLoggedIn, isPanAadharLinked) => ({
  tdsPercent: isLoggedIn && isPanAadharLinked ? TDS_WITH_SEEDING : TDS_WITHOUT_SEEDING,
  tdsMessage: isLoggedIn
    ? (!isPanAadharLinked ? TDS_TOOLTIP_MESSAGE : "")
    : TDS_LOGIN_TOOLTIP_MESSAGE
});